import React from 'react'
import { string } from 'prop-types'
import { H1, Paragraph, Color } from '@cobalt/cobalt-react-components'

const ContentHeader = ({ title, message }) => (
  <div className="co--align-center vertical-space bottom-space">
    <H1 asH3>{title}</H1>
    {message ? (
      <Paragraph color={Color.gray[600]}>{message}</Paragraph>
    ) : (
      <React.Fragment />
    )}
  </div>
)

ContentHeader.propTypes = {
  title: string.isRequired,
  message: string
}

export default ContentHeader
